import React, { useState } from 'react';
import '../styles/Signup.css';
import apiService from '../services/apiService';
import { SubscriptionDropdown } from '../components/Dropdowns';
import { useNavigate } from 'react-router-dom';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { errorLines } from '../utils/apiError';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirm_password: "",
    name: "",
    email: "",
    // Empty, not "Select Subscription Type": that placeholder text was being POSTed
    // verbatim and rejected with a 422. It is the dropdown's placeholder option value.
    subscription: "",
  });
  const [errors, setErrors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    // The API only accepts Free / Basic / Premium, so there is nothing to send until
    // the user has actually picked one.
    if (!formData.subscription) {
      setErrors(['Please choose a subscription type.']);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.signup(formData);

      if (!response) {
        // No response at all — the request never reached the API.
        setErrors(['Network error. Please check your connection and try again.']);
      } else if (response.status === 201) {
        // Signup does not return a session; the user logs in next.
        navigate('/login', {
          state: { message: response.data.message + " You may now login." },
        });
      } else {
        // 400 hands back a string ("Username or email already registered."),
        // 422 an array of field errors. Both are worth showing verbatim.
        setErrors(errorLines(response.data?.detail));
      }
    } catch (err) {
      setErrors(['Network error. Please try again.']);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="signup-container">
        <div className="signup-box">
          <h2 className="signup-title">Signup to AdvPOS App</h2>

          {errors.length > 0 && (
            <div className="signup-error" role="alert">
              {errors.map((line, index) => (
                <p key={`${index}-${line}`}>{line}</p>
              ))}
            </div>
          )}

          <form onSubmit={handleSubmit} className="signup-form">
            <input
              id="username"
              type="text"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              name="username"
              className="signup-input"
            />
            <input
              id="password"
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              name="password"
              className="signup-input"
            />
            <input
              id="confirm_password"
              type="password"
              placeholder="Confirm Password"
              value={formData.confirm_password}
              onChange={handleChange}
              name="confirm_password"
              className="signup-input"
            />
            <input
              id="name"
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              name="name"
              className="signup-input"
            />
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              name="email"
              className="signup-input"
            />
            <SubscriptionDropdown value={formData.subscription} onChange={handleChange} />
            {!formData.subscription && (
              <p className="signup-hint">Choose a subscription type to continue.</p>
            )}
            <button
              type="submit"
              className="signup-button"
              disabled={isSubmitting || !formData.subscription}
            >
              {isSubmitting ? "Submitting..." : "Signup"}
            </button>
          </form>
          <GoogleSignInButton onError={(msg) => setErrors([msg])} />
        </div>
      </div>
    </div>
  );
};

export default Signup;
